module.exports = __webpack_public_path__ + "img/product_40.1d503cd.webp";